import { Component, HostBinding, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VerfuegungFacade, VerfuegungResource } from '@schir-int-client/verfuegung-shared';
import { Observable, Subscription, withLatestFrom } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApiRootFacade, ApiRootLinkRel } from '@schir-int-client/api-root';
import { getUrl } from '@ngxp/rest';

@Component({
	selector: 'schir-int-client-aufgaben-in-verfuegung-container',
	templateUrl: './aufgaben-in-verfuegung-container.component.html',
	styleUrls: ['./aufgaben-in-verfuegung-container.component.scss'],
	host: { class: 'x-section' },
	standalone: false,
})
export class AufgabenInVerfuegungContainerComponent implements OnDestroy {
	verfuegung: Observable<VerfuegungResource>;
	private subscriptions: Subscription[] = [];
	visible: boolean;

	constructor(verfuegungFacade: VerfuegungFacade, route: ActivatedRoute, apiRootFacade: ApiRootFacade) {
		this.verfuegung = route.params.pipe(
			withLatestFrom(apiRootFacade.getCurrentApiRoot()),
			switchMap(([route, apiRoot]) => {
				verfuegungFacade.loadVerfuegung(
					getUrl(apiRoot, ApiRootLinkRel.VERFUEGUNGS) + '/' + route['verfuegungId']
				);
				return verfuegungFacade.verfuegung;
			})
		);
		this.subscriptions.push(
			this.verfuegung.subscribe(verfuegung => {
				this.visible = verfuegung != null;
			})
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(s => s.unsubscribe());
	}

	@HostBinding('class')
	public get class(): string {
		return this.visible ? 'x-section' : 'x-section-hidden';
	}
}
